(function () {
  'use strict';

  // Antes usaba IntersectionObserver, pero en algunos celulares los bloques
  // se quedaban en opacity:0 para siempre (secciones "vacías" reportadas en
  // producción). Se cambió a una comprobación directa de posición en scroll,
  // más predecible entre navegadores, con doble red de seguridad: se revisa
  // también en load y con un timeout corto por si el layout cambia al
  // terminar de cargar imágenes/fuentes.
  function initReveals() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.vv-reveal'));
    if (!els.length) return;

    function revisar() {
      var alto = window.innerHeight || document.documentElement.clientHeight;
      els = els.filter(function (el) {
        var r = el.getBoundingClientRect();
        var visible = r.top < alto * 0.92 && r.bottom > 0;
        if (visible) el.classList.add('vv-visible');
        return !visible;
      });
      if (!els.length) {
        window.removeEventListener('scroll', onScrollOrResize);
        window.removeEventListener('resize', onScrollOrResize);
      }
    }

    // La página fue creciendo (más tarjetas, pasos, secciones) y con ella la
    // cantidad de .vv-reveal por revisar. Sin limitar a un cálculo por frame,
    // un scroll rápido en celulares de gama media/baja dispara "revisar()"
    // decenas de veces por segundo y cada llamada mide varios elementos con
    // getBoundingClientRect — eso puede sentirse como que la página se
    // congela. Se agrupa con requestAnimationFrame para que corra como
    // máximo una vez por frame sin cambiar el resultado visual.
    var vvTicking = false;
    function onScrollOrResize() {
      if (vvTicking) return;
      vvTicking = true;
      window.requestAnimationFrame(function () {
        revisar();
        vvTicking = false;
      });
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    window.addEventListener('load', revisar);
    revisar();
    setTimeout(revisar, 800);
    // Última red de seguridad: si algo sigue sin mostrarse a los 2.5s
    // (bug desconocido, fuente/imagen lenta que movió el layout), se fuerza
    // para que nunca quede contenido invisible de forma permanente.
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('vv-visible'); });
    }, 2500);
  }

  function initMarquees() {
    var tracks = document.querySelectorAll('.vv-marquee-track[data-vv-duplicate]');
    tracks.forEach(function (track) {
      if (track.dataset.vvDuplicated) return;
      track.innerHTML += track.innerHTML;
      track.dataset.vvDuplicated = 'true';
    });
  }

  function initFaq() {
    var items = document.querySelectorAll('.vv-faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.vv-faq-pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.contains('vv-faq-abierto');
        items.forEach(function (i) {
          i.classList.remove('vv-faq-abierto');
          var b = i.querySelector('.vv-faq-pregunta');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('vv-faq-abierto');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // Galería de la página de producto: la miniatura elegida cambia la imagen grande.
  function initGaleriaProducto() {
    var principal = document.getElementById('vv-imagen-principal');
    var miniaturas = document.querySelectorAll('.vv-miniatura');
    var videoWraps = document.querySelectorAll('.vv-video-wrap');
    if (!miniaturas.length) return;
    miniaturas.forEach(function (btn) {
      btn.addEventListener('click', function () {
        miniaturas.forEach(function (b) { b.style.borderColor = 'transparent'; });
        btn.style.borderColor = 'var(--vv-accent)';

        var videoId = btn.getAttribute('data-vv-video-id');
        videoWraps.forEach(function (wrap) {
          var esta = videoId && wrap.getAttribute('data-vv-video-id') === videoId;
          wrap.style.display = esta ? 'block' : 'none';
          if (!esta) {
            var vid = wrap.querySelector('video');
            if (vid) vid.pause();
          }
        });

        if (videoId) {
          if (principal) principal.style.display = 'none';
          return;
        }

        var url = btn.getAttribute('data-vv-imagen');
        if (!url || !principal) return;
        principal.style.display = '';
        principal.src = url;
      });
    });
  }

  /* Los tres manejadores siguientes usan delegación en `document` a propósito.
     <cart-items> de Dawn se vuelve a renderizar con la Section Rendering API en
     cada cambio de cantidad y sustituye ese trozo del DOM, así que cualquier
     listener atado directamente al nodo se pierde en silencio. */

  // Botón 🗑️ del header: vacía el carrito y recarga.
  // Confirmación propia en vez de window.confirm(): los diálogos nativos del
  // navegador se bloquean o pasan inadvertidos en varios contextos (vista
  // previa del editor de temas, apps/WebViews móviles), y el clic parecía
  // "no hacer nada".
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#vv-btn-vaciar-carrito-header');
    if (!btn) return;
    if (btn.dataset.vvConfirmando !== 'true') {
      btn.dataset.vvConfirmando = 'true';
      var textoOriginal = btn.innerHTML;
      btn.innerHTML = '¿Vaciar?';
      btn.style.opacity = '1';
      btn.style.borderColor = 'var(--vv-accent-dark, #a85639)';
      btn.style.color = 'var(--vv-accent-dark, #a85639)';
      btn.style.width = 'auto';
      btn.style.padding = '6px 10px';
      var resetear = function () {
        delete btn.dataset.vvConfirmando;
        btn.innerHTML = textoOriginal;
        btn.style.color = '';
        btn.style.width = '';
        btn.style.padding = '8px';
      };
      btn._vvResetTimeout = setTimeout(resetear, 3000);
      btn._vvResetear = resetear;
      return;
    }
    clearTimeout(btn._vvResetTimeout);
    btn.disabled = true;
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () { window.location.reload(); })
      .catch(function () {
        btn.disabled = false;
        if (btn._vvResetear) btn._vvResetear();
      });
  });

  // Códigos de estado que usa el checkout de Shopify en su <select name="zone">,
  // mapeados desde los mismos 32 nombres que ya usa vv-sepomex.json.
  var VV_CODIGOS_ESTADO = {
    'Aguascalientes': 'AGS',
    'Baja California': 'BC',
    'Baja California Sur': 'BCS',
    'Campeche': 'CAMP',
    'Chiapas': 'CHIS',
    'Chihuahua': 'CHIH',
    'Ciudad de México': 'DF',
    'Coahuila de Zaragoza': 'COAH',
    'Colima': 'COL',
    'Durango': 'DGO',
    'Guanajuato': 'GTO',
    'Estado de Guerrero': 'GRO',
    'Estado de Hidalgo': 'HGO',
    'Jalisco': 'JAL',
    'Estado de México': 'MEX',
    'Michoacán': 'MICH',
    'Morelos': 'MOR',
    'Nayarit': 'NAY',
    'Nuevo León': 'NL',
    'Oaxaca': 'OAX',
    'Puebla': 'PUE',
    'Querétaro': 'QRO',
    'Quintana Roo': 'Q ROO',
    'San Luis Potosí': 'SLP',
    'Sinaloa': 'SIN',
    'Sonora': 'SON',
    'Tabasco': 'TAB',
    'Tamaulipas': 'TAMPS',
    'Tlaxcala': 'TLAX',
    'Veracruz': 'VER',
    'Yucatán': 'YUC',
    'Zacatecas': 'ZAC'
  };

  // "Paga al Recibir" en el carrito: limpia el descuento de tarjeta antes de ir al checkout.
  // Si el cliente ya buscó su código postal en el widget de SEPOMEX, se lo
  // pasamos al checkout como código postal, ciudad Y estado precargados.
  // El Estado solo se queda fijo si se manda junto con el país explícito
  // (country=Mexico) — sin eso, Shopify lo sobreescribe con el de la tienda.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#vv-btn-cod');
    if (!btn) return;
    e.preventDefault();

    if (!window.vvSepomexCheckoutParams) {
      var cpInput = document.getElementById('vv-sepomex-cp');
      var cpResultado = document.getElementById('vv-sepomex-resultado');
      if (cpInput) {
        cpInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        cpInput.focus();
        cpInput.style.transition = 'box-shadow 0.3s ease';
        cpInput.style.boxShadow = '0 0 0 3px rgba(200, 109, 81, 0.25)';
        setTimeout(function () { cpInput.style.boxShadow = ''; }, 2000);
      }
      if (cpResultado) {
        vvSepomexPintar(cpResultado, '<p class="vv-sepomex-neutro">👆 Un último paso: ingresa tu código postal para activar tu envío gratis.</p>');
      }
      return;
    }

    var destino = btn.href;
    if (window.vvSepomexCheckoutParams) {
      var datos = window.vvSepomexCheckoutParams;
      var separador = destino.indexOf('?') === -1 ? '?' : '&';
      destino += separador
        + 'checkout%5Bshipping_address%5D%5Bzip%5D=' + encodeURIComponent(datos.zip)
        + '&checkout%5Bshipping_address%5D%5Bcity%5D=' + encodeURIComponent(datos.city)
        + '&checkout%5Bshipping_address%5D%5Bcountry%5D=' + encodeURIComponent('Mexico');
      var codigoEstado = VV_CODIGOS_ESTADO[datos.province];
      if (codigoEstado) {
        destino += '&checkout%5Bshipping_address%5D%5Bprovince%5D=' + encodeURIComponent(codigoEstado);
      }
    }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
      .catch(function () {})
      .finally(function () { window.location.href = destino; });
  });

  // Evita el doble envío del formulario de compra de la página de producto.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#vv-form-producto');
    if (!form) return;
    var btn = document.getElementById('vv-btn-comprar');
    if (btn) btn.disabled = true;
  });

  // Miniatura del upsell de sueros en el carrito: mismo efecto de zoom +
  // video que el order bump de producto. Se usa delegación con mouseover/
  // mouseout (en vez de mouseenter/mouseleave, que no burbujean) para que
  // funcione aunque el snippet se re-renderice o aparezca más de una vez.
  document.addEventListener('mouseover', function (e) {
    var media = e.target.closest('.vv-cross-sell-media');
    if (!media || media.dataset.vvHover === 'true') return;
    media.dataset.vvHover = 'true';
    media.style.transform = 'scale(2.4)';
    var img = media.querySelector('img');
    var video = media.querySelector('video');
    if (img) img.style.opacity = '0';
    if (video) { video.style.opacity = '1'; video.currentTime = 0; video.play(); }
  });
  document.addEventListener('mouseout', function (e) {
    var media = e.target.closest('.vv-cross-sell-media');
    if (!media || (e.relatedTarget && media.contains(e.relatedTarget))) return;
    delete media.dataset.vvHover;
    media.style.transform = 'scale(1)';
    var img = media.querySelector('img');
    var video = media.querySelector('video');
    if (img) img.style.opacity = '1';
    if (video) { video.style.opacity = '0'; video.pause(); }
  });

  // Botones "Pedir con Pago al Recibir" de las tarjetas de oferta del inicio
  // (sección Ritual Principal): cada botón trae su propia lista de variantes
  // en data-items, igual que el order bump de producto. A diferencia del
  // order bump (que va directo a checkout), estas tarjetas pasan primero por
  // el carrito a propósito, para que el cliente use el buscador de código
  // postal (SEPOMEX) antes de pagar.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vv-oferta-add]');
    if (!btn || btn.disabled) return;
    var items;
    try {
      items = JSON.parse(btn.getAttribute('data-items'));
    } catch (err) {
      return;
    }
    btn.disabled = true;
    var textoOriginal = btn.innerHTML;
    btn.textContent = 'Procesando...';
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (res) {
        if (!res.ok) { throw new Error('No se pudo agregar al carrito'); }
        window.location.href = '/cart';
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = textoOriginal;
        alert('Hubo un problema al procesar tu pedido, intenta de nuevo.');
      });
  });

  // Botón "Agregar a mi pedido" del upsell de sueros en el carrito.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vv-cross-sell-add]');
    if (!btn || btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.disabled = true;
    var textoOriginal = btn.innerHTML;
    btn.textContent = 'Agregando...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) { throw new Error('No se pudo agregar al carrito'); }
        window.location.reload();
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = textoOriginal;
        alert('Hubo un problema al agregar el producto, intenta de nuevo.');
      });
  });

  // Validador de cobertura por Código Postal (SEPOMEX), en el carrito. No
  // toca el checkout (no es posible) — resuelve Estado/Municipio oficiales,
  // los guarda en cart.attributes (para la orden y Dropi) y los precarga en
  // la URL del botón de checkout. Delegado en `document` porque el carrito
  // se vuelve a renderizar con la Section Rendering API en cada cambio de
  // cantidad.
  var vvSepomexData = null;
  var vvSepomexLoading = null;

  function vvSepomexCargar() {
    if (vvSepomexData) return Promise.resolve(vvSepomexData);
    if (vvSepomexLoading) return vvSepomexLoading;
    if (!window.vvSepomexUrl) return Promise.reject(new Error('vvSepomexUrl no definido'));
    vvSepomexLoading = fetch(window.vvSepomexUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        vvSepomexData = data;
        return data;
      });
    return vvSepomexLoading;
  }

  var vvSepomexUltimoGuardado = null;

  function vvSepomexPintar(resultado, html) {
    // Reinicia la animación de fundido quitando y volviendo a poner la clase
    // (si solo se cambia el innerHTML, la animación CSS no se re-dispara).
    resultado.classList.remove('vv-sepomex-fade');
    void resultado.offsetWidth;
    resultado.innerHTML = html;
    resultado.classList.add('vv-sepomex-fade');
  }

  document.addEventListener('input', function (e) {
    var input = e.target.closest('#vv-sepomex-cp');
    if (!input) return;
    input.value = input.value.replace(/\D/g, '').slice(0, 5);
    var resultado = document.getElementById('vv-sepomex-resultado');
    if (!resultado) return;

    if (input.value.length !== 5) {
      // Borrado/edición: quita el estado de éxito sin alarmas, vuelve a la guía neutra.
      input.classList.remove('vv-sepomex-input--valido');
      delete window.vvSepomexCheckoutParams;
      vvSepomexPintar(resultado, '<p class="vv-sepomex-neutro">Ingresa tus 5 dígitos para asignar tu paquetería local.</p>');
      return;
    }

    // Ya se guardó este mismo C.P. — no hay nada nuevo que buscar ni que
    // mandar al carrito, evita una llamada de red innecesaria.
    if (vvSepomexUltimoGuardado === input.value) return;

    vvSepomexPintar(resultado, '<span style="color:var(--vv-text-soft);">Asignando tu paquetería local...</span>');
    delete window.vvSepomexCheckoutParams;
    vvSepomexCargar()
      .then(function (data) {
        var registro = data.cp[input.value];
        if (!registro) {
          input.classList.remove('vv-sepomex-input--valido');
          vvSepomexPintar(resultado, '<p class="vv-sepomex-neutro">Revisa tu código postal, parece tener un dígito de más o de menos.</p>');
          return;
        }
        var estado = data.e[registro[0]];
        var municipio = data.m[registro[1]];
        window.vvSepomexCheckoutParams = { zip: input.value, city: municipio, province: estado };
        input.classList.add('vv-sepomex-input--valido');
        vvSepomexPintar(resultado, '<p class="vv-sepomex-exito">✓ Cobertura confirmada para ' + municipio + ', ' + estado + '. Envío gratis activado.</p>');
        vvSepomexUltimoGuardado = input.value;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              CP_Validado: input.value,
              Municipio_Normalizado: municipio,
              Estado_Normalizado: estado
            }
          })
        }).catch(function () {});
      })
      .catch(function () {
        input.classList.remove('vv-sepomex-input--valido');
        vvSepomexPintar(resultado, '<p class="vv-sepomex-neutro">No pudimos confirmar tu cobertura por ahora, intenta de nuevo en un momento.</p>');
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initMarquees();
    initFaq();
    initGaleriaProducto();
  });
})();
